import Vue from 'vue';
import Router from 'vue-router';
import * as views from './views/*.vue';
import isBlockedByOrigin from './helpers/isBlockedByOrigin';

import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: views.Dashboard,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/appinfo',
      name: 'AppInfo',
      component: views.AppInfo,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'customercare']
      }
    },
    {
      path: '/combinations',
      name: 'Combinations',
      component: views.Combinations,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    },
    {
      path: '/whitelabels',
      name: 'Whitelabels',
      component: views.Whitelabels,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/platforms',
      name: 'Platforms',
      component: views.Platforms,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/builds',
      name: 'Builds',
      component: views.Builds,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: views.Users,
      meta: {
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/userslogs',
      name: 'Users Logs',
      component: views.UsersLogs,
      meta: {
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/installations',
      name: 'Installations',
      component: views.Installations,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/testerEmails',
      name: 'Tester emails',
      component: views.TesterEmails,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    },
    {
      path: '/testersPhones',
      name: 'Testers phones',
      component: views.TestersPhones,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    },
    {
      path: '/testerIP',
      name: 'Tester IPs',
      component: views.TesterIP,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    },
    {
      path: '/testRequest',
      name: 'Test Request',
      component: views.TestRequest,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/appVersionsOnTest',
      name: 'App versions on test',
      component: views.AppVersionsOnTest,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/localisations',
      name: 'Localisations',
      component: views.Localisations,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/wlConfig',
      name: 'wlConfig',
      component: views.WlConfig,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/goalsAbtesting',
      name: 'goalsAbtesting',
      component: views.GoalsAbtesting,
      children: [],
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/achievedGoals',
      name: 'achievedGoals',
      component: views.AchievedGoals,
      children: [],
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/abtesting',
      name: 'abtesting',
      component: views.ABTesting,
      children: [],
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/abtesting/:collectionId',
      name: 'usersForCollection',
      component: views.UsersForAbTesting,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/login',
      name: 'login',
      component: views.Login,
      meta: {
        requiresNotAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/techSupport',
      name: 'TechSupport',
      component: views.TechSupport,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer']
      }
    },
    {
      path: '/pipelines',
      name: 'Pipelines',
      component: views.Pipelines,
      meta: {
        requiresAuth: true,
        roles: ['admin', 'developer', 'tester']
      }
    }
    //_ROUTER_PLACEHOLDER
  ]
});

router.beforeEach((to, from, next) => {
  if (isBlockedByOrigin(store)) {
    next(false);
    return;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (!to.meta.roles) {
        return next();
      }
      const role = store.state.user.role;
      if (to.meta.roles.includes(role)) {
        next();
        return;
      }
      switch (role) {
        case 'tester':
          next('/testerIP');
          break;
        case 'customercare':
          next('/appinfo');
          break;
        default:
          next(false);
          break;
      }
      return;
    }
    next('/login');
  } else if (to.matched.some(record => record.meta.requiresNotAuth)) {
    if (store.getters.isLoggedIn) {
      next('/');
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
